module.exports = "https://neera-retreat.sgp1.cdn.digitaloceanspaces.com/assets/experiences/spaces/03_04_atnight.png";